function convertToKB(bytes: number) {
	return bytes / 1024;
}

function convertToMB(bytes: number) {
	return bytes / 1024 ** 2;
}

export function formatBytes(bytes?: number) {
	if (!bytes || bytes < 0) {
		return "";
	}

	if (bytes < 10) {
		return `${bytes} bytes`;
	}

	if (bytes < 900) {
		return `${convertToKB(bytes).toFixed(2)} KB`;
	}

	if (bytes < 1024 ** 2) {
		return `${convertToKB(bytes).toFixed(0)} KB`;
	}

	return `${convertToMB(bytes).toFixed(0)} MB`;
}
